import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { authProtectedFlattenRoutes, publicProtectedFlattenRoutes, authPartialProtectedFlattenRoutes } from './index';
import { RouteRendererProps } from './types';
import { RootState } from '../app/store/store';
import HorizontalLayout from '../layouts/Horizontal';
import { LocationAwareClientContext } from './LocationAwareClientContext';
import DefaultLayout from '../layouts/Default';
import Error404 from '../pages/error/Error404';

const RouteRenderer = ({ routes }: RouteRendererProps) => (
  <Switch>
    {routes.map(route => {
      if (route.children) return null;
      const RouteComponent = route.route || Route;
      return (
        <RouteComponent
          key={route.path}
          path={route.path}
          roles={route.roles}
          exact={route.exact}
          component={route.component || (() => <div>Component not found</div>)}
        />
      );
    })}
    <Redirect to="/error-404" />
  </Switch>
);

const Routes = () => {
  const { layout } = useSelector((state: RootState) => ({
    layout: state.Layout,
  }));

  const Layout = HorizontalLayout;

  return (
    <BrowserRouter>
      <LocationAwareClientContext>
        <Switch>
          {/* Public routes with DefaultLayout */}
          <Route path={publicProtectedFlattenRoutes.map(r => r.path)}>
            <DefaultLayout layout={layout}>
              <RouteRenderer routes={publicProtectedFlattenRoutes} />
            </DefaultLayout>
          </Route>

          {/* Auth-protected routes with HorizontalLayout */}
          <Route path={authProtectedFlattenRoutes.map(r => r.path)}>
            <Layout>
              <RouteRenderer routes={authProtectedFlattenRoutes} />
            </Layout>
          </Route>

          {/* Client context routes with HorizontalLayout */}
          <Route path={authPartialProtectedFlattenRoutes.map(r => r.path)}>
            <Layout>
              <RouteRenderer routes={authPartialProtectedFlattenRoutes} />
            </Layout>
          </Route>

          {/* Catch-all route for 404 errors */}
          <Route>
            <DefaultLayout layout={layout}>
              <Error404 errorText="Page not found" />
            </DefaultLayout>
          </Route>
        </Switch>
      </LocationAwareClientContext>
    </BrowserRouter>
  );
};

export default Routes;
